// extracted by mini-css-extract-plugin
export default {"label":"styles_label__fAr0W","label--invalid":"styles_label--invalid__tGzZm","label--disabled":"styles_label--disabled__+fuFF"};